import gql from 'graphql-tag';

export const FACEBOOK_IMPORT_REQUESTS_QUERY = gql`
  query FacebookImportRequestsQuery($filter: FacebookImportRequestsFilterInput!, $first: Int, $after: String) {
    facebookImportRequests(filter: $filter, first: $first, after: $after) {
      edges {
        node {
          id
          status
          facebookObjectId
          optOutFromRunner
          optOutFromCampaignReuse
          lastError
          createdAt
          article {
            id
            title
            campaignId
            campaign {
              flipperFeatures {
                name
                enabled
              }
            }
          }
          requestedBy {
            id
            email
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;
